import * as React from "react";
import { Typography } from "@material-ui/core";
import { LocalizerHelper } from "../../helpers/localizerHelper";
import { MenuItem, CookingIngredient, Minus } from "../../models/menuItem";

interface Props {
  menuItem: MenuItem;
  cookingIngredients: CookingIngredient[];
}

export const MenuItemIngredients: React.FC<Props> = ({
  menuItem,
  cookingIngredients,
}) => {
  const minusPaths = menuItem.minus?.map((m: Minus) => m.id) ?? [];

  const filtered = cookingIngredients.filter(
    (item) =>
      !minusPaths.includes(item.path)
  );

  const extra =
    menuItem.ingredients_description
      ? `, ${menuItem.ingredients_description.toLowerCase()}`
      : "";

  return (
    <>
      <div className="row" style={{ marginTop: 15 }}>
        <div className="col-12">
          <Typography variant="h5" gutterBottom className="menu-item-sub-header" align="left">
            {LocalizerHelper.localized("ingredients")}
          </Typography>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          {filtered
            .map((item) =>
              LocalizerHelper.localized(item, ["name"])
            )
            .join(", ")}
          {extra}
        </div>
      </div>
    </>
  );
};
